import React, { useEffect } from "react";
import NotFound from "./not_found";
import PermissionDenied from "permission_denied";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import { Navigate, Route, Link } from "react-router-dom";
import OrganisationSignUp from "layouts/authentication/org-sign-up";
import { logout } from "helpers/navigation";
function AuthGuard({ route }) {

	const user = JSON.parse(localStorage.getItem("user"))
  const routePermissions = user?.permissions_all?.[route.permissionKey];
  const hasRoutePermission = (value) =>
    routePermissions?.some((permission) => permission === value || permission?.includes("leave_admin"));
  if (user !== null) {
    if (route.requireRole) {
      if (
        (user !== null) &&
        (user?.permissions_all[
          route.permissionKey
        ] != undefined) && (
          hasRoutePermission(route?.modulePermissions.list_permission) ||
          hasRoutePermission(route?.modulePermissions.view_permission) ||
          hasRoutePermission(route?.modulePermissions.own_list_permission) ||
          hasRoutePermission(route?.modulePermissions.leave_admin_permission) ||
          hasRoutePermission(route?.modulePermissions.balance_admin_permission) ||
          hasRoutePermission(route?.modulePermissions.transaction_admin_permission) ||
          hasRoutePermission(route?.modulePermissions.approval_admin_permission)
        )
      ) {
        return React.cloneElement(
          route.component,
          {
            userid: user?.employee_id,
            permissions: user
              ?.permissions_all[route.permissionKey],
            modulePermissions: route?.modulePermissions,
          },
          {
            state: {
              userid: user.employee_id,
              permissions: user
                ?.permissions_all[route.permissionKey],
              modulePermissions: route?.modulePermissions,
            },
          }
        );
      } else {
        return route.permission_denied_component;
      }
    } else {
      return React.cloneElement(route.component, {
        permissions: Array.isArray(route.permissionKey)
          ? route.permissionKey
              .map(
                (e) =>
                  user?.permissions_all[e]
              )
              .flat(Infinity)
          : user?.permissions_all[
              route.permissionKey
            ],
        modulePermissions: route?.modulePermissions,
      });
    }
  } else if (route.name == "OrgSignUp") {
    return <OrganisationSignUp />;
  } else {
    return <SignInIllustration />;
  }
}

export default AuthGuard;
